export const isProduction = process.env.NEXT_PUBLIC_ENV !== "test";

export const siteUrl = "https://vetina.eu";
